// extracted by mini-css-extract-plugin
export default {"root":"BenefactorConsentedDocuments_root__2F49v"};